import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

export default class Header extends Component {
  state = {
    redirect: null
  };

  GoBackClicked = goBackPath => {
    this.setState({ redirect: goBackPath });
  };

  render() {
    const { label, goBackPath } = this.props;
    const { redirect } = this.state;

    if (redirect) return <Redirect to={redirect} />;

    return (
      <div className="header">
        {goBackPath ? (
          <Button
            outline
            color="info"
            onClick={() => {
              this.setState({ redirect: goBackPath });
            }}
          >
            <FontAwesomeIcon icon={["fas", "chevron-left"]} size="1x" />
          </Button>
        ) : (
          ""
        )}
        {label}
      </div>
    );
  }
}

Header.propTypes = {
  label: PropTypes.string.isRequired
};
